import MuiAccordion, { type AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { type AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails, { type AccordionDetailsProps } from "@mui/material/AccordionDetails";
import MuiAccordionActions, { type AccordionActionsProps } from "@mui/material/AccordionActions";

export type {
  AccordionProps,
  AccordionSummaryProps,
  AccordionDetailsProps,
  AccordionActionsProps,
};

export function Accordion(props: AccordionProps) {
  return <MuiAccordion {...props} />;
}

export function AccordionSummary(props: AccordionSummaryProps) {
  return <MuiAccordionSummary {...props} />;
}

export function AccordionDetails(props: AccordionDetailsProps) {
  return <MuiAccordionDetails {...props} />;
}

export function AccordionActions(props: AccordionActionsProps) {
  return <MuiAccordionActions {...props} />;
}
